import StockListPage from './StockListPage'

export default StockListPage
